import React, {forwardRef} from 'react';
import classNames from 'classnames';
import {
    ThumbnailRefs,
    ArtworkItem,
    Thumbnail,
} from '../ContentItemViewArtworkTypes&Const';
import ContentItemViewArtworkThumbnailsItem from './ContentItemViewArtworkThumbnailsItem';

interface Props {
    artworks: ArtworkItem[];
    className?: string;
    title: string;
    icon?: JSX.Element;
    currentZoomId: number;
    setCurrentZoomId: Function;
    currentId?: number;
    setCurrentId?: Function;
    thumbnailRefs: ThumbnailRefs;
    handleZoomIn: Function;
    onDebouncedImageSelect?: Function;
    name: string;
    qcId: string;
    isModalOpen: string;
    setArtworkReplace: () => void;
}

export const ContentItemViewArtworkThumbnails = forwardRef(
    (
        {artworks, className, title, icon, setArtworkReplace, ...restProps}: Props,
        ref: Thumbnail
    ) => {
        if (!artworks.length) return null;

        const classes = classNames('carousel__thumbnails', className);

        return (
            <>
                <div className="content-item-artwork-title">
                    <span>{title}</span>
                    {icon}
                </div>
                <div className={classes} ref={ref}>
                    {artworks.map((image: ArtworkItem) => (
                        <ContentItemViewArtworkThumbnailsItem
                            thumbnail={ref}
                            key={image.id}
                            {...restProps}
                            {...image}
                            setArtworkReplace={setArtworkReplace}
                        />
                    ))}
                </div>
            </>
        );
    }
);

export default ContentItemViewArtworkThumbnails;
